// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__17XVZ","clinicsSelect":"TableHeading_clinicsSelect__1qxf7"};